import { useEffect, useState } from "react";

// Shared responsive hook. Desktop/tablet remains untouched when `false`.
// Breakpoint mirrors Tailwind `md:` (768px).
export const useIsMobile = (breakpoint = 767) => {
    const getMatch = () =>
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia(`(max-width: ${breakpoint}px)`).matches;

    const [isMobile, setIsMobile] = useState(getMatch);

    useEffect(() => {
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
            return undefined;
        }
        const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);
        const onChange = (e) => setIsMobile(e.matches);
        setIsMobile(mq.matches);
        // Safari <14 uses deprecated addListener
        if (mq.addEventListener) mq.addEventListener("change", onChange);
        else mq.addListener(onChange);
        return () => {
            if (mq.removeEventListener) mq.removeEventListener("change", onChange);
            else mq.removeListener(onChange);
        };
    }, [breakpoint]);

    return isMobile;
};

export const usePrefersReducedMotion = () => {
    const get = () =>
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const [reduced, setReduced] = useState(get);

    useEffect(() => {
        if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
            return undefined;
        }
        const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
        const onChange = (e) => setReduced(e.matches);
        setReduced(mq.matches);
        if (mq.addEventListener) mq.addEventListener("change", onChange);
        else mq.addListener(onChange);
        return () => {
            if (mq.removeEventListener) mq.removeEventListener("change", onChange);
            else mq.removeListener(onChange);
        };
    }, []);

    return reduced;
};

export default useIsMobile;
